package org.hs_soft.runmynesto.domain.model.home.product.products_list_model


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import org.hs_soft.runmynesto.domain.model.general_error_model.GeneralError

@Serializable
data class ProductListModel(
    @SerialName("data")
    val data: Data?,
    @SerialName("errors")
    val errors: List<GeneralError?>?=null,
)